<template src='./subsidy-report.html'/>

<script>
import ContextPage from '@/components/context-page/ContextPage'
import Vue from 'vue'
import FileSaver from 'file-saver'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from '@/mixins/validation'
import i18n from '@/i18n'
import { EventBus } from '@/router/bus'

export default {
  mixins: [validationMixin],
  components: {
    ContextPage
  },
  computed: {
    userTypeErrors () {
      return this.getRetrieveValidationErrorsByName('userType')
    },
    formattedFilterFromDate () {
      if (!this.filter.from) {
        return null
      }
      return this.formatShortDate(this.filter.from)
    },
    formattedFilterToDate () {
      if (!this.filter.to) {
        return null
      }
      return this.formatShortDate(this.filter.to)
    }
  },
  created () {
    this.retrieveNotifications()
  },
  data () {
    return {
      menuDatePickerFrom: false,
      menuDatePickerTo: false,
      filter: {
        from: null,
        to: null,
        userType: null,
        bankId: null
      },
      loading: false,
      exportUserTypeSelectItems: [
        { value: 1, text: i18n.t('exportUserTypes.' + 1) },
        { value: 2, text: i18n.t('exportUserTypes.' + 2) },
        { value: 4, text: i18n.t('exportUserTypes.' + 4) },
        { value: 5, text: i18n.t('exportUserTypes.' + 5) }
      ],
      exportUserType: {
        RetiredAndBeneficiary: 1,
        Beneficiary: 2,
        Others: 4,
        Cumulative: 5
      },
      notification: null
    }
  },
  methods: {
    retrieveNotifications () {
      this.loading = true
      this.orders = []
      this.orderSum = 0
      // add api get request to roles and groups, localRoles and groups are muck for now
      this.$http.get(Vue.$apiConfig.notificationsGet).then(
        response => {
          this.logConsole(response)
          EventBus.$emit('system-notification', {
            message: response.data.payload.text,
            variant: 'error'
          })
          this.loading = false
        },
        error => {
          this.logConsole(error)
          this.loading = false
        }
      )
    },
    getRetrieveValidationErrorsByName (name) {
      if (!this.$v.filter[name].$dirty) return []
      return this.getValidationErrors('filter').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    validateAndSubmitExcelReport () {
      this.$v.filter.$touch()
      if (this.$v.filter.$invalid) {
        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.excelReport()
    },
    excelReport () {
      this.loading = true
      this.$http.post(Vue.$apiConfig.subsidyReportPost, this.filter, { responseType: 'blob' })
        .then(response => {
          this.loading = false
          var headers = response.headers
          var blob = new Blob([response.data], { type: headers['content-type'] })
          FileSaver.saveAs(blob, this.$t('exportUserTypes.' + this.filter.userType) + ' ' + this.formatShortDate(new Date()) + 'xlsx')
        },
        error => {
          this.loading = false
          this.logConsole(error)
          this.formatErrorResponse(error)
        })
    }
  },
  validations () {
    const filterRules = {}

    Object.assign(filterRules, {
      userType: {
        required
      }
    })

    return {
      filter: filterRules
    }
  }
}
</script>
